var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import ErrorContainer from "../../errorContainer";
import "./styles.css";
export var ErrorMain = function (_a) {
    // const classProps = useMemo(() => className ?? "", [className]);
    var 
    // errorExpiryHour,
    // className,
    // style,
    toggleDrawer = _a.toggleDrawer, isDrawerOpen = _a.isDrawerOpen;
    // const [hoverOnDrawerButton, setHoverOnDrawerButton] =
    //   useState<boolean>(false);
    // const toggleHoverOnDrawerButton = useCallback(
    //   (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    //     e.preventDefault();
    //     setHoverOnDrawerButton((prev) => !prev);
    //   },
    //   []
    // );
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: isDrawerOpen
                    ? "rjsFEP3fs9_side_drawer open"
                    : "rjsFEP3fs9_side_drawer" }, { children: isDrawerOpen ? _jsx(ErrorContainer, {}) : _jsx(_Fragment, {}) })), isDrawerOpen && (_jsx("div", { className: "rjsFEP3fs9_backdrop", onClick: toggleDrawer }))] }));
};
export default ErrorMain;
